import styled from 'styled-components';

export const PageHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }

  width: 100vw;
  padding: 2rem 5rem;
  background: #eff1f3;
  position: fixed;
  z-index: 50;
`;
